module.exports = __webpack_public_path__ + "assets/img/SAI-block-329.ce8d1824.png";